import React from 'react';
import { Reducer } from 'redux';
import { GlobalActions, GlobalActionTypes } from './globalActions';

export interface GlobalState {
    openSpinner: boolean;
    importingOrExporting: boolean;
    readonly: boolean;
    taskRefresh: boolean;
    uploadingFileTasks: Record<string, { message: string, progress: number|null }>;
    standardGridView: boolean;
    useCaseGridView: boolean;
    scopeGridView: boolean;
    workflowRepresentationGridView: boolean;
    dockedDialogs: Record<string, React.ReactNode>;
    finishedBackgroundTasks: string[];
    idleTime: number;
}

export const defaultState: GlobalState = {
    openSpinner: false,
    importingOrExporting: false,
    readonly: false,
    taskRefresh: false,
    standardGridView: false,
    useCaseGridView: false,
    scopeGridView: false,
    workflowRepresentationGridView: false,
    uploadingFileTasks: {},
    dockedDialogs: {},
    finishedBackgroundTasks: [],
    idleTime: 0,
};

export const globalReducer: Reducer<GlobalState, GlobalActions> = (state = defaultState, action: GlobalActions) => {
    switch (action.type) {
        case GlobalActionTypes.OPEN_SPINNER_STATE:
            return {
                ...state,
                openSpinner: action.payload.openSpinner,
            };
        case GlobalActionTypes.IMPORTING_OR_EXPORTING_PROJECT_STATE:
            return {
                ...state,
                importingOrExporting: action.payload.importingOrExporting,
            };
        case GlobalActionTypes.SET_TASK_REFRESH:
            return {
                ...state,
                taskRefresh: action.payload.taskRefresh,
            };
        case GlobalActionTypes.SET_STANDARD_GRID_VIEW:
            return {
                ...state,
                standardGridView: action.payload.gridView,
            };
        case GlobalActionTypes.SET_USECASE_GRID_VIEW:
            return {
                ...state,
                useCaseGridView: action.payload.gridView,
            };
        case GlobalActionTypes.SET_SCOPE_GRID_VIEW:
            return {
                ...state,
                scopeGridView: action.payload.gridView,
            };
        case GlobalActionTypes.SET_WORKFLOW_REPRESENTATION_GRID_VIEW:
            return {
                ...state,
                workflowRepresentationGridView: action.payload.gridView,
            };
        case GlobalActionTypes.ADD_FILE_UPLOAD_TASK:
            const newUploadingFileTasks = state.uploadingFileTasks ? { ...state.uploadingFileTasks } : {};
            newUploadingFileTasks[action.payload.id] = {
                message: action.payload.message,
                progress: action.payload.progress
                //abortController: action.payload.abortController,
            };
            return {
                ...state,
                uploadingFileTasks: newUploadingFileTasks,
            };
        case GlobalActionTypes.UPDATE_PROGRESS_FILE_UPLOAD_TASK:
            const updatedUploadingFileTasks = state.uploadingFileTasks ? { ...state.uploadingFileTasks } : {};
            if (action.payload.id in updatedUploadingFileTasks) {
                updatedUploadingFileTasks[action.payload.id] = {
                    message: updatedUploadingFileTasks[action.payload.id].message,
                    progress: action.payload.progress
                };
                return {
                    ...state,
                    uploadingFileTasks: updatedUploadingFileTasks,
                };
            }
            return state
        case GlobalActionTypes.REMOVE_FILE_UPLOAD_TASK:
            const newUploadingFileTaskRemoving: Record<string, { message: string, progress: number|null }> = {};
            Object.keys(state.uploadingFileTasks).forEach(value => {
                if (value !== action.payload.id) {
                    newUploadingFileTaskRemoving[value] = state.uploadingFileTasks[value];
                }
            });
            return {
                ...state,
                uploadingFileTasks: newUploadingFileTaskRemoving,
            };
        case GlobalActionTypes.ADD_DOCKED_DIALOG:
            const newDockedDialogs = state.dockedDialogs ? { ...state.dockedDialogs } : {};
            newDockedDialogs[action.payload.title] = action.payload.dialogContent;
            return {
                ...state,
                dockedDialogs: newDockedDialogs,
            };
        case GlobalActionTypes.REMOVE_DOCKED_DIALOG:
            const newRemovingDockedDialogs: Record<string, React.ReactNode> = {};
            Object.keys(state.dockedDialogs).forEach(value => {
                if (value !== action.payload.title) {
                    newRemovingDockedDialogs[value] = state.dockedDialogs[value];
                }
            });
            return {
                ...state,
                dockedDialogs: newRemovingDockedDialogs,
            };
        case GlobalActionTypes.ALL_REMOVE_FILE_UPLOAD_TASK:
            return {
                ...state,
                uploadingFileTasks: {},
            };
        case GlobalActionTypes.ALL_REMOVE_DOCKED_DIALOGS:
            return {
                ...state,
                dockedDialogs: {},
            };
        case GlobalActionTypes.ADD_FINISHED_BACKGROUND_TASK:
            const newList = state.finishedBackgroundTasks ? [...state.finishedBackgroundTasks] : [];
            newList.push(action.payload.backgroundTask);
            return {
                ...state,
                finishedBackgroundTasks: newList,
            };

        case GlobalActionTypes.SET_IDLE_TIME:
            return {
                ...state,
                idleTime: action.payload.idleTime,
            };
        case GlobalActionTypes.LOGOUT:
            return state;
        default:
            return state;
    }
};
